import { useEffect, useState } from 'react';
import { HELP_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import GOALS from '../constants/GOALS';
import { sendGoal } from '../helpers/metrika';
import useBasketSize from './useBasketSize';
import useTranslate from './useTranslate';

const useHelp = () => {
  const { Widget } = window;
  const [isHidden, toggleHelp] = useState(true);
  const { t } = useTranslate();
  const basketSize = useBasketSize();

  const handleUpdateState = ({ isHidden: hidden }) => {
    toggleHelp(hidden);
  };

  useEffect(() => {
    Widget.helpController.addListener(HELP_EVENTS.UPDATE, handleUpdateState);
    return () => {
      Widget.helpController.removeListener(HELP_EVENTS.UPDATE, handleUpdateState);
    };
  }, []);

  const hide = () => {
    Widget.helpController.hide();
    sendGoal(GOALS.UNDERSTAND_BUTTON);
  };

  return {
    isHidden,
    t,
    basketSize,
    hide,
  };
};

export default useHelp;
